/**
 * All permissions used in the security of the admin portal
 * (spares devs mystery strings in the UI)
 */
const permission = {
  view: {
    accountConfiguration: 'ADM_ACC_MGMT_CONFIG_VIEW',
    accountManagement: 'ADM_ACC_MGMT_VIEW',
    addRooms: 'ADM_PROPERTY_ROOMS_VIEW',
    approvals: 'ADM_APPROVAL_VIEW',
    approvalsConfiguration: 'ADM_APPROVAL_CONFIG_VIEW',
    bookingManagement: 'ADM_BOOK_MGMT_VIEW',
    cardManagement: 'ADM_CARD_MGMT_VIEW',
    connectionManagement: 'ADM_CONN_MGMT_VIEW',
    csNewPreview: 'CS_NEW_PREVIEW',
    customerManagement: 'ADM_CUST_MGMT_VIEW',
    customerRequests: 'ADM_CUST_REQ_VIEW',
    customerPreferencesView: 'ADM_CUSTPREF_VIEW',
    dashboard: 'ADM_DASH_VIEW',
    featureFlagManagement: 'ADM_FLAG_MGMT_VIEW',
    folio: 'ADM_FOLIO_VIEW',
    guestDays: 'ADM_GUEST_DAYS_VIEW',
    helpTickets: 'ADM_TICKET_VIEW',
    invoices: 'ADM_INVOICE_VIEW',
    margins: 'ADM_MARGIN_MGMT_VIEW',
    missingFolios: 'ADM_MISSING_FOLIOS_VIEW',
    payment: 'ADM_PAYMENT_VIEW',
    rateCard: 'ADM_RATE_CARD_VIEW',
    reconciliation: 'ADM_RECON_VIEW',
    roleManagement: 'ADM_ROLE_MGMT_VIEW',
    supplierManagement: 'ADM_SUPP_MGMT_VIEW',
    taxTemplate: 'ADM_TAX_TMPL_VIEW',
    userManagement: 'ADM_USER_MGMT_VIEW',
    vcc: 'ADM_VCC_VIEW',
    productTeam: 'PRODUCT_TEAM',
    propertyLocalTime: 'PROPERTY_LOCAL_TIME',
    property: 'ADM_PROPERTY_VIEW',
    permission: 'ADM_VIEW_PERMISSION'
  },
  edit: {
    accountConfiguration: 'ADM_ACC_MGMT_CONFIG_EDIT',
    accountManagement: 'ADM_ACC_MGMT_EDIT',
    accessGallery: 'ADM_PROPERTY_GALLERY_EDIT',
    addRooms: 'ADM_ROOMS_EDIT',
    addUser: 'ADM_ADD_USER',
    approvals: 'ADM_APPROVAL_EDIT',
    approvalsConfiguration: 'ADM_APPROVAL_CONFIG_EDIT',
    assignRole: 'ADM_ASSIGN_ROLE',
    bookingManagement: 'ADM_BOOK_MGMT_EDIT',
    bulkTaxTemplate: 'ADM_BULK_TAX_TMPLT_EDIT',
    cardManagement: 'ADM_CARD_MGMT_EDIT',
    cardManagementCX: 'ADM_CX_CARD_MGMT_EDIT',
    connectionManagement: 'ADM_CONN_MGMT_EDIT',
    createPaymentID: 'ADM_CREATE_PAYMENT_ID',
    creditApplicationManagement: 'ADM_CREDIT_APP_MGMT',
    csApproved: 'CS_CAN_APPROVE',

    csArchived: 'CS_CAN_ARCHIVE_DRAFT_AND_EXCEPTION',
    csArchiveSent: 'CS_CAN_ARCHIVE_SENT',
    csArchiveApproved: 'CS_CAN_ARCHIVE_APPROVED',
    csArchiveReadyToInvoice: 'CS_CAN_ARCHIVE_READY_TO_INVOICE',
    csArchiveDisputed: 'CS_CAN_ARCHIVE_DISPUTED',

    csDraftSent: 'CS_CAN_DRAFT_SENT',
    csEditCreditCard: 'ADM_CS_CC_EDIT',
    csInvoiced: 'CS_CAN_INVOICE',
    csPaid: 'CS_CAN_PAID',
    csCanDispute: 'CS_CAN_DISPUTE',
    csExtendedDate: 'CS_EXTENDED_DATE',
    customerManagement: 'ADM_CUST_MGMT_EDIT',
    customerRequests: 'ADM_CUST_REQ_EDIT',
    customerState: 'ADM_CUST_STATE_EDIT',
    customerDomainSuffix: 'ADM_CUST_DOMAIN_SUFFIX_EDIT',
    customerAPContact: 'ADM_AP_CONTACT_EDIT',
    customerInvoiceTypeEdit: 'ADM_INVOICETYPE_EDIT',
    customerInvoicePreferenceCrewEdit: 'ADM_INVOICEPREF_CREW_EDIT',
    featureFlagManagement: 'ADM_FLAG_MGMT_EDIT',
    folio: 'ADM_FOLIO_EDIT',
    guestDays: 'ADM_GUESTDAYS_EDIT',
    helpTickets: 'ADM_TICKET_EDIT',
    invoices: 'ADM_INVOICE_EDIT',
    margins: 'ADM_MARGIN_MGMT_EDIT',
    mccManagement: 'ADM_MCC_MGMT_EDIT',
    payment: 'ADM_PAYMENT_EDIT',
    paymentId: 'ADM_PAYMENT_ID_EDIT',
    trackingCode: 'ADM_TRACKING_CODE_EDIT',
    rateCard: 'ADM_RATE_CARD_EDIT',
    recLineItems: 'REC_LINE_ITEMS',
    reconciliation: 'ADM_RECON_EDIT',
    resetFolio: 'ADM_FOLIO_RESET',
    roleManagement: 'ADM_ROLE_MGMT_EDIT',
    supplierManagement: 'ADM_SUPP_MGMT_EDIT',
    taxTemplate: 'ADM_TAX_TMPL_EDIT',
    taxManagement: 'ADM_TAX_MGMT',
    userManagement: 'ADM_USER_MGMT_EDIT',
    vcc: 'ADM_VCC_EDIT',
    vccUnblock: 'ADM_VCC_UNBLOCK',
    crewList: 'CREW_LIST_REQUIRED',
    permission: 'ADM_EDIT_PERMISSION',
    deleteFolio: 'ADM_FOLIO_DELETE',
    inviteCustomer: 'ADM_INVITE_CUSTOMER',
    property: 'ADM_PROPERTY_EDIT',
    propertyContact: 'ADM_PROPERTY_CONTACT_EDIT',
    guestNames: 'ADM_GUESTNAMES_EDIT',
    editReconciled: 'ADM_CAN_EDIT_RECONCILED'
  },
  copy: {
    vccDetailsCopy: 'ADM_VCC_DETAILS_COPY'
  },
  trigger: {
    triggerVccUpdate: 'ADM_TRIGGER_VCC_UPDATE'
  },
  create: {
    trackingCode: 'ADM_TRACKING_CODE_CREATE',
    chargeSheets: 'ADM_CHARGESHEET_CREATE',
    booking: 'ADM_BOOKING_CREATE'
  }
};

Object.freeze(permission);

export { permission };
